import { render, staticRenderFns } from "./customerReport.vue?vue&type=template&id=8a839b88&scoped=true"
import script from "./customerReport.vue?vue&type=script&lang=js"
export * from "./customerReport.vue?vue&type=script&lang=js"
import style0 from "./customerReport.vue?vue&type=style&index=0&id=8a839b88&prod&scoped=true&lang=css"
import style1 from "./customerReport.vue?vue&type=style&index=1&id=8a839b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a839b88",
  null
  
)

export default component.exports